import { render } from "./error-page.vue?vue&type=template&id=f53b6dd6"
import script from "./error-page.vue?vue&type=script&lang=js"
export * from "./error-page.vue?vue&type=script&lang=js"

import "./error-page.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__